var o;!function(o){o.Apple="SignInWithApple",o.Amazon="LoginWithAmazon",o.Facebook="Facebook",o.Google="Google"}(o||(o={}));export{o as FederatedIdentityProviders};
